import React from "react";

const InlineGroup = ({
  formValues,
  item,
  mapChildren,
  onChange,
  ownKey,
  setFormValues,
  validationErrors,
  ctx,
  showQuestionId,
  showQuestionKey,
}) => {
  return (
    <div className="flex flex-row">
      {mapChildren({
        parentSchema: item,
        formValues,
        parentKey: ownKey,
        onChange,
        setFormValues,
        validationErrors,
        ctx,
        showQuestionId,
        showQuestionKey,
      })}
    </div>
  );
};

export default InlineGroup;
